import { render, staticRenderFns } from "./AddDeviceTariff.vue?vue&type=template&id=19f5af20&scoped=true"
import script from "./AddDeviceTariff.vue?vue&type=script&lang=js"
export * from "./AddDeviceTariff.vue?vue&type=script&lang=js"
import style0 from "./AddDeviceTariff.vue?vue&type=style&index=0&id=19f5af20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f5af20",
  null
  
)

export default component.exports